/**
 * LIC vehicle → bulb-base starter dataset (FR/EU popular models).
 */

// 1. BASE DE DONNÉES AUTOS
window.LIC_VEHICLE_FITMENT = {
  "Renault": {
    "Twingo II (2007-2014)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Twingo III (2014+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Clio III (2005-2012)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Clio IV (2012-2019)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Clio V (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Megane III (2008-2016)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Megane IV (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Laguna III (2007-2015)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Captur I (2013-2019)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Captur II (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Scenic III (2009-2016)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Espace V (2015-2023)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Kadjar (2015+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Koleos I (2008-2016)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Talisman (2015+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Kangoo II (2007-2021)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Kangoo III (2021+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Peugeot": {
    "108 (2014-2021)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "207 (2006-2014)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "208 I (2012-2019)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "208 II (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "2008 I (2013-2019)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "2008 II (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "308 II (2013-2021)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "308 III (2021+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "3008 I (2009-2016)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "3008 II (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "407 (2004-2011)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "5008 II (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "508 I (2010-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "508 II (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Partner II (2008-2018)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Rifter (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Traveller (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Citroën": {
    "C1 II (2014-2021)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "C3 II (2009-2016)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "C3 III (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "C3 Aircross (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "DS3 (2010-2016)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "DS4 (2011-2018)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "C4 II (2010-2018)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "C4 III (2020+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "C4 Cactus (2014+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "C4 Picasso II (2013-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "C5 Aircross (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Berlingo III (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Jumpy III (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Dacia": {
    "Sandero II (2012-2020)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Sandero III (2020+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Duster I (2010-2017)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Duster II (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Logan II (2012+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Jogger (2021+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Volkswagen": {
    "Up! (2011+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Polo V (2009-2017)": { "dipped": "h4", "main": "h4", "fog": "h8" },
    "Polo VI (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Golf VI (2008-2012)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Golf VII (2012-2020)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Golf VIII (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Tiguan I (2007-2016)": { "dipped": "h7", "main": "h15", "fog": "h11" },
    "Tiguan II (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "T-Roc (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Passat B8 (2014+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Arteon (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Touran II (2015+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Touareg II (2010-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Caddy III (2004-2015)": { "dipped": "h7", "main": "h15", "fog": "h11" },
    "Caddy IV (2015-2020)": { "dipped": "h7", "main": "h15", "fog": "h11" },
    "Transporter T5 (2003-2015)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Transporter T6 (2015+)": { "dipped": "h4", "main": "h4", "fog": "h11" }
  },
  "Audi": {
    "A1 (2010-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "A3 8V (2012-2020)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "A3 8Y (2020+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "A4 B8 (2007-2015)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "A4 B9 (2015+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "A5 B8 (2007-2016)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "A6 C7 (2011-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "TT 8J (2006-2014)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Q3 (2011-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Q5 (2008-2017)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "BMW": {
    "Serie 1 F20 (2011-2019)": { "dipped": "h7", "main": "h7", "fog": "h8" },
    "Serie 1 F40 (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Serie 3 E46 (1998-2005)": { "dipped": "h7", "main": "h7", "fog": "hb4" },
    "Serie 3 E90 (2005-2011)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Serie 3 F30 (2011-2019)": { "dipped": "h7", "main": "h7", "fog": "h8" },
    "Serie 3 G20 (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Serie 5 E60 (2003-2010)": { "dipped": "h7", "main": "h7", "fog": "hb4" },
    "Serie 5 F10 (2010-2017)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "X1 F48 (2015+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "X3 F25 (2010-2017)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "X5 E70 (2006-2013)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Mercedes-Benz": {
    "Classe A W176 (2012-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Classe A W177 (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Classe B W246 (2011-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Classe C W204 (2007-2014)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Classe C W205 (2014-2021)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "GLA (2013+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "GLC (2015+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Toyota": {
    "Aygo (2014+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Yaris III (2011-2020)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Yaris IV (2020+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Auris I (2007-2012)": { "dipped": "h11", "main": "hb3", "fog": "h11" },
    "Auris II (2012-2018)": { "dipped": "h11", "main": "hb3", "fog": "h11" },
    "Corolla (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Prius III (2009-2015)": { "dipped": "h11", "main": "hb3", "fog": "h11" },
    "C-HR (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "RAV4 (2013-2018)": { "dipped": "h11", "main": "hb3", "fog": "h11" },
    "RAV4 (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Land Cruiser 150 (2009+)": { "dipped": "h11", "main": "hb3", "fog": "h11" },
    "Hilux (2015+)": { "dipped": "h4", "main": "h4", "fog": "h11" }
  },
  "Ford": {
    "Fiesta VII (2008-2017)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Fiesta VIII (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Focus III (2011-2018)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Focus IV (2018+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Mondeo IV (2014-2022)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Kuga II (2013-2019)": { "dipped": "h7", "main": "h15", "fog": "h11" },
    "Kuga III (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Puma (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Transit Custom (2012-2023)": { "dipped": "h7", "main": "h15", "fog": "h11" }
  },
  "Opel": {
    "Corsa D (2006-2014)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Corsa E (2014-2019)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Corsa F (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Astra J (2009-2015)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Astra K (2015-2021)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Mokka / Mokka X": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Crossland": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Seat": {
    "Ibiza IV (2008-2017)": { "dipped": "h7", "main": "h1", "fog": "h8" },
    "Ibiza V (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Leon III (2012-2020)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Leon IV (2020+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Arona (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Ateca (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Škoda": {
    "Fabia II (2007-2014)": { "dipped": "h4", "main": "h4", "fog": "h8" },
    "Fabia III (2014-2021)": { "dipped": "h7", "main": "h7", "fog": "h8" },
    "Octavia III (2013-2020)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Octavia IV (2020+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Superb III (2015+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Kodiaq (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Kamiq (2019+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Fiat": {
    "500 (2007+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "500X (2014+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Panda (2011+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Tipo (2015+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "500L (2012+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Hyundai": {
    "i20 (2014+)": { "dipped": "h4", "main": "h4", "fog": "h8" },
    "i30 (2011+)": { "dipped": "h7", "main": "h7", "fog": "h8" },
    "Tucson (2015+)": { "dipped": "h7", "main": "hb3", "fog": "h11" },
    "Kona (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Kia": {
    "Picanto III (2017+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Rio (2011+)": { "dipped": "h4", "main": "h4", "fog": "h8" },
    "Stonic (2017+)": { "dipped": "h7", "main": "hb3", "fog": "h11" },
    "Ceed (2012+)": { "dipped": "h7", "main": "h7", "fog": "h8" },
    "Sportage (2015+)": { "dipped": "h7", "main": "hb3", "fog": "h11" },
    "Niro (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Nissan": {
    "Micra (2010+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Juke (2010+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Qashqai (2013+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "X-Trail (2014+)": { "dipped": "h7", "main": "hb3", "fog": "h11" }
  },
  "Honda": {
    "Jazz (2008+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Civic (2012+)": { "dipped": "h7", "main": "hb3", "fog": "h11" },
    "CR-V (2012+)": { "dipped": "h11", "main": "hb3", "fog": "h11" },
    "HR-V (2015+)": { "dipped": "h11", "main": "hb3", "fog": "h11" }
  },
  "Mazda": {
    "Mazda2 (2007+)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Mazda3 (2009+)": { "dipped": "h7", "main": "hb3", "fog": "h11" },
    "Mazda6 (2012+)": { "dipped": "h11", "main": "h15", "fog": "h11" },
    "MX-5 NC (2005-2015)": { "dipped": "h7", "main": "hb3", "fog": "h11" },
    "CX-3 (2015+)": { "dipped": "h11", "main": "hb3", "fog": "h11" },
    "CX-5 (2012+)": { "dipped": "h11", "main": "hb3", "fog": "h11" }
  },
  "Mini": {
    "Cooper R56 (2006-2013)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Cooper F56 (2014+)": { "dipped": "h7", "main": "h7", "fog": "h8" },
    "Countryman (2010+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Volvo": {
    "V40 (2012+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "XC60 (2008-2017)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "XC60 II (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "V60 (2010+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Suzuki": {
    "Swift (2010+)": { "dipped": "h4", "main": "h4", "fog": "h8" },
    "Vitara (2015+)": { "dipped": "h7", "main": "hb3", "fog": "h11" },
    "Ignis (2016+)": { "dipped": "h4", "main": "h4", "fog": "h8" }
  },
  "Mitsubishi": {
    "Space Star (2012+)": { "dipped": "h4", "main": "h4", "fog": "h8" },
    "ASX (2010+)": { "dipped": "h7", "main": "hb3", "fog": "h11" },
    "Outlander (2012+)": { "dipped": "h7", "main": "hb3", "fog": "h11" }
  },
  "Jeep": {
    "Renegade (2014+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Compass (2017+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Land Rover": {
    "Range Rover Evoque (2011+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Discovery Sport (2014+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Smart": {
    "Fortwo 451 (2007-2014)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Fortwo 453 (2014+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Subaru": {
    "XV / Crosstrek (2012+)": { "dipped": "h11", "main": "hb3", "fog": "h11" },
    "Forester (2013+)": { "dipped": "h7", "main": "hb3", "fog": "h11" }
  },
  "Alfa Romeo": {
    "Giulietta (2010+)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "MiTo (2008+)": { "dipped": "h7", "main": "h1", "fog": "h11" },
    "Stelvio (2016+)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Porsche": {
    "Macan (2014+)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Cayenne II (2011-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" }
  },
  "Lexus": {
    "CT200h (2011-2020)": { "dipped": "h11", "main": "h9", "fog": "h11" },
    "IS III (2013-2020)": { "dipped": "h11", "main": "hb3", "fog": "h11" }
  },
  "Chevrolet": {
    "Spark (2010-2015)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Aveo (2011-2015)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Cruze (2009-2016)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Captiva (2006-2018)": { "dipped": "h7", "main": "h1", "fog": "h11" }
  }
};


// 2. BASE DE DONNÉES MOTOS
window.LIC_VEHICLE_FITMENT_MOTO = {
  "Yamaha": {
    "MT-07 (2014-2020)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "MT-09 (2013-2016)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "Tracer 700 (2016-2019)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "TMAX 530 (2012-2016)": { "dipped": "h11", "main": "h11", "fog": "h11" },
    "FZ6 (2004-2010)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "XJ6 (2009-2016)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "FZ8 (2010-2016)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "YZF-R1 (2004-2008)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "X-MAX 125/250 (2010-2017)": { "dipped": "h7", "main": "h7", "fog": "h7" }
  },
  "Kawasaki": {
    "Z650 (2017-2019)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "Z750 (2007-2012)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "Z800 (2013-2016)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "Z900 (2017-2019)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "Z1000 (2010-2013)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "Versys 650 (2015-2021)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "ER-6N (2012-2016)": { "dipped": "h11", "main": "h11", "fog": "h11" },
    "Ninja 300 (2013-2017)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "Ninja 400 (2018+)": { "dipped": "h7", "main": "h7", "fog": "h7" }
  },
  "Suzuki": {
    "SV 650 (2016-2022)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "Bandit 650 (2009-2015)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "V-Strom 650 (2017+)": { "dipped": "h7", "main": "h9", "fog": "h11" },
    "GSR 750 (2011-2016)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "GSX-S 750 (2017+)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "GSX-R 1000 (2009-2016)": { "dipped": "h11", "main": "h9", "fog": "h9" },
    "Burgman 125/200 (2007-2013)": { "dipped": "h7", "main": "h7", "fog": "h7" }
  },
  "Honda": {
    "CB 500F (2013-2018)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "CB 650F (2014-2018)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "CB 600F Hornet (2007-2013)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "CB 1000R (2008-2017)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "CRF 1000L Africa Twin (2016-2019)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "CBR 600 RR (2007-2012)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "PCX 125 (2010-2014)": { "dipped": "h4", "main": "h4", "fog": "h4" }
  },
  "Triumph": {
    "Street Triple 675 (2007-2016)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "Street Triple 765 (2017+)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "Speed Triple 1050 (2011-2020)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "Tiger 800 (2010-2020)": { "dipped": "h4", "main": "h4", "fog": "h11" },
    "Bonneville T120 (2016+)": { "dipped": "h4", "main": "h4", "fog": "h4" }
  },
  "BMW Motorrad": {
    "R 1200 GS (2004-2012)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "R 1200 GS (2013-2018)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "F 800 GS (2008-2017)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "S 1000 RR (2009-2018)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "R nineT (2014+)": { "dipped": "h4", "main": "h4", "fog": "h4" }
  },
  "Ducati": {
    "Monster 696/796/1100 (2008-2014)": { "dipped": "h7", "main": "h7", "fog": "h7" },
    "Monster 821 (2014-2020)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "Multistrada 1200 (2010-2014)": { "dipped": "h7", "main": "h7", "fog": "h11" },
    "Scrambler 800 (2015+)": { "dipped": "h4", "main": "h4", "fog": "h4" }
  },
  "KTM": {
    "125 Duke (2011-2016)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "390 Duke (2013-2016)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "790 Duke (2018-2020)": { "dipped": "h4", "main": "h4", "fog": "h4" },
    "1290 Super Adventure (2015-2020)": { "dipped": "h11", "main": "h11", "fog": "h11" }
  }
};


// 3. NORMALISATION
/** Map near-aliases to catalog culot keys */
window.LIC_CULOT_NORMALIZE = {
  h8: "h11",
  h9: "h11",
  h11: "h11",
  h1: "h1",
  h4: "h4",
  h7: "h7",
  hb3: "hb3",
  hb4: "hb4",
  h15: "h15",
  d1: "d1",
  d2: "d1",
  d3: "d1",
  d4: "d1"
};